<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pdt-15 pdb-15 bg-white">
      <el-form ref="form" :model="form" label-width="90px" inline>
        <el-form-item label="合伙人姓名">
          <el-input
            v-model="form.userName"
            placeholder="请输入合伙人姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="合伙人电话">
          <el-input
            v-model="form.userPhone"
            placeholder="请输入合伙人电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="账号状态">
          <el-select v-model="form.status" placeholder="全部" clearable>
            <el-option label="正常" :value="0"></el-option>
            <el-option label="冻结" :value="1"></el-option>
            <el-option label="锁定" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              getList();
              getState();
            "
            >查 询
          </el-button>
          <el-button
            @click="
              form = {};
              getList();
              getState();
            "
            >重 置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <btns @exec="exec" class="mgb-20"></btns>
    <!-- 统计 -->
    <div class="flex aic fw-600 color0063ea mgt-20 mgb-20">
      <span class="mgr-50">合伙人总数(人)：{{ stateForm.partnerNum }}</span>
      <span class="mgr-50">正常(人)：{{ stateForm.normalNum }}</span>
      <span class="mgr-50">冻结(人)：{{ stateForm.freezeNum }}</span>
      <!--      <span class="mgr-50"-->
      <!--        >删除(人)：{{ stateForm.delNum ? stateForm.delNum : 0 }}</span-->
      <!--      >-->
      <div class="flex ">
        <span>锁定(人)：{{ stateForm.lockNum }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="说明"
          placement="top-start"
        >
          <div class="wenhao" @click="dongjieVisible = true">?</div>
        </el-tooltip>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="partnerNum" label="合伙人编号"></el-table-column>
      <el-table-column prop="userName" label="合伙人姓名"></el-table-column>
      <el-table-column prop="userPhone" label="合伙人电话"></el-table-column>
      <el-table-column prop="regionNum" label="管理分区数"></el-table-column>
      <el-table-column prop="status" label="账号状态">
        <template slot-scope="scope">
          <span style="color: #67C23A" v-if="scope.row.status === 0">正常</span>
          <span style="color: var(--text-sub)" v-else-if="scope.row.status === 1"
            >冻结</span
          >
          <span style="color: var(--danger)" v-else>锁定</span>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间"></el-table-column>

      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情
          </el-button>
          <el-button
            v-if="scope.row.status === 2"
            type="text"
            size="small"
            @click="handleUnlock(scope.row)"
            >解锁
          </el-button>
          <!--          <el-button-->
          <!--              v-if="scope.row.status === 1"-->
          <!--              type="text"-->
          <!--              size="small"-->
          <!--              @click="handleUnfreeze(scope.row)"-->
          <!--          >解冻-->
          <!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 冻结说明弹框 -->
    <el-dialog
      title="说明"
      :visible.sync="dongjieVisible"
      width="30%"
      center
      top="30vh"
    >
      <div class="f18">冻结：有经营数据，但不继续使用的账号。</div>
      <!--      <div class="f18 mgt-15 mgb-15">-->
      <!--        删除：无任何经营数据且被删除的合伙人账号。-->
      <!--      </div>-->
      <div class="f18">锁定：业绩考核未达标的合伙人账号。</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dongjieVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
    <!--    提现设置弹窗-->
    <el-dialog
      title="提现设置"
      :visible.sync="tixianVisible"
      width="30%"
      center
      top="30vh"
      @close=""
    >
      <el-form ref="tixianForm" :model="tixianForm" label-width="110px">
        <el-form-item label="提现周期">
          <el-radio-group v-model="tixianForm.withdrawPeriodStatus">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="周期选择"
          v-if="tixianForm.withdrawPeriodStatus === 1"
        >
          <el-select v-model="tixianForm.withdrawPeriod" placeholder="周期选择">
            <el-option label="1天" :value="1"></el-option>
            <el-option label="7天" :value="7"></el-option>
            <el-option label="15天" :value="15"></el-option>
            <el-option label="30天" :value="30"></el-option>
            <el-option label="90天" :value="90"></el-option>
            <el-option label="180天" :value="180"></el-option>
            <el-option label="365天" :value="365"></el-option>
          </el-select>
          <div style="color: red">合伙人多少天内可提现次数。</div>
        </el-form-item>
        <el-form-item label="可提现比例">
          <el-radio-group v-model="tixianForm.withdrawProportionStatus">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="可提现比例设置"
          v-if="tixianForm.withdrawProportionStatus === 1"
        >
          <el-input-number
            v-model.number="tixianForm.withdrawProportion"
            placeholder="请输入可提现比例"
            min="0"
            max="100"
            :precision="0"
          >
          </el-input-number>
          <span style="margin-left: 10px">%</span>
          <div style="color: red">合伙人至多可提取钱包内金额的比例。</div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="tixianSure">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import { assignObject } from "@/utils/UtilsIf";
const initTixianData = () => ({
  withdrawPeriod: "",
  withdrawPeriodStatus: 0,
  withdrawProportionStatus: 0,
  withdrawProportion: ""
});
export default {
  components: {
    breadcrumbs,
    btns
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {
        userPhone: "",
        userName: "",
        status: ""
      },
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      multipleSelection: [],
      dongjieVisible: false,
      tixianVisible: false,
      stateForm: {},
      tixianForm: initTixianData() //提现表单
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    }
  },
  created() {
    this.getList();
    this.getState();
  },
  methods: {
    // 解锁
    handleUnlock(row) {
      handleConfirm("确定对绩效考核未达标的合伙人账户解锁吗?", "info")
        .then(() => {
          this.$api.partner.partnerUnlock({ id: row.id }).then(res => {
            if (res.code === 200) {
              handleAlert("合伙人已解锁", "success");
              this.getList();
              this.getState();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // 解栋
    handleUnfreeze(row) {
      handleConfirm("确定对合伙人账户解冻吗?", "info")
        .then(() => {
          this.$api.partner.partnerUnfreeze({ id: row.id }).then(res => {
            if (res.code === 200) {
              handleAlert("合伙人已解冻", "success");
              this.getList();
              this.getState();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    // 统计
    getState() {
      this.$api.partner
        .partnerState({
          userName: this.form.userName,
          userPhone: this.form.userPhone,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime
        })
        .then(res => {
          if (res.code === 200) {
            this.stateForm = res.data;
          }
        });
    },
    // 合伙人删除
    del() {
      if (this.multipleSelection.length === 0) {
        handleAlert("请选择数据", "error");
        return;
      }
      handleConfirm("合伙人删除后无法恢复，确认删除吗?", "info")
        .then(() => {
          let arr = [];
          this.multipleSelection.forEach(v => {
            arr.push(v.id);
          });
          this.$api.partner.partnerDel(arr).then(res => {
            if (res.code === 200) {
              handleAlert("删除成功", "success");
              this.getList();
              this.getState();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    //提现确定
    tixianSure() {
      this.$api.partner
        .tixianSetting({
          ...this.tixianForm,
          withdrawProportion: this.tixianForm.withdrawProportion
            ? Number(this.tixianForm.withdrawProportion) / 100
            : "",
          ids: this.multipleSelection.map(i => i.id)
        })
        .then(res => {
          if (res.code === 200) {
            this.tixianForm = initTixianData();
            this.tixianVisible = false;
            this.getList();
            this.getState();
          }
        });
    },
    // 合伙人冻结
    freeze() {
      if (this.multipleSelection.length === 0) {
        handleAlert("请选择数据", "error");
        return;
      }
      handleConfirm(
        "合伙人账号冻结后无法恢复，且合伙人无法登录该账号，确定冻结吗?",
        "info"
      )
        .then(() => {
          let arr = [];
          this.multipleSelection.forEach(v => {
            arr.push(v.id);
          });
          this.$api.partner.partnerFreeze(arr).then(res => {
            if (res.code === 200) {
              handleAlert("冻结成功", "success");
              this.getList();
              this.getState();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    // 列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.partner
        .partnerList({
          pageNum: this.page,
          pageSize: this.pageSize,
          userName: this.form.userName,
          userPhone: this.form.userPhone,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime
        })
        .then(res => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    handleDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/partner/partnerManage/partnerDetail",
        query: {
          id: row.id,
          partnerId: row.futureUserId
        }
      });
    },
    // 编辑按钮
    update() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条设备", "error");
        return;
      }
      if (this.multipleSelection.every(v => v.status !== 0)) {
        handleAlert("账号冻结或锁定无法修改！", "error");
        return;
      }
      this.$router.push({
        path: "/partner/partnerManage/partnerAdd",
        query: {
          id: this.multipleSelection[0].id
        }
      });
    },
    //设置按钮
    setting() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条设备", "error");
        return;
      }
      this.tixianForm = assignObject(this.tixianForm, {
        ...this.multipleSelection[0],
        withdrawProportion: this.multipleSelection[0].withdrawProportion
          ? this.multipleSelection[0].withdrawProportion * 100
          : ""
      });
      this.tixianVisible = true;
    },
    // 新增按钮
    add() {
      this.$router.push({
        path: "/partner/partnerManage/partnerAdd"
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.wenhao {
  width: 15px;
  height: 15px;
  border: 2px solid var(--accent);
  text-align: center;
  line-height: 15px;
  border-radius: 50%;
  margin-left: 3px;
  cursor: pointer;
}
</style>
